
import { css } from 'lit';
export default css`
pc-aside-list ul{
    color:var(--neutral-charcoal);
    list-style-type:disc;
    padding:var(--spacing-4);
    font-size:var(--fs-sm);
  }
    @media (min-width: 992px){pc-aside-list ul{
      font-size:var(--fs-lg)
  }
    }
    pc-aside-list ul li{
      padding-bottom:var(--spacing-4);
      line-height:var(--lh-body);
    }
    @media (min-width: 992px){
    pc-aside-list ul li{
        padding-bottom:var(--spacing-6)
    }
      }
    pc-aside-list ul li:last-of-type{
      padding-bottom:0px;
    }
    pc-aside-list ul li::marker{
      color:var(--purple-medium-neutral);
    }

pc-aside-list:last-of-type ul{
  border-bottom:var(--purple-medium-neutral) 2px solid;
}`;